// --- START PATCH: AdminLayout with left sidebar navigation and Outlet ---
import { NavLink, Outlet } from "react-router-dom";
import clsx from "clsx";

function itemClasses(isActive: boolean) {
  return clsx(
    "block rounded-md px-3 py-2 text-sm font-medium transition-colors",
    "hover:bg-accent hover:text-accent-foreground",
    isActive ? "bg-primary text-primary-foreground" : "bg-transparent"
  );
}

export default function AdminLayout() {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 grid grid-cols-1 md:grid-cols-[220px_1fr] gap-6">
      <aside className="md:sticky md:top-20 self-start">
        <div className="rounded-lg border bg-card p-3 no-underline-links">
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-2">Admin</div>
          <nav className="space-y-1">
            <NavLink to="/admin/inventory" className={({ isActive }) => itemClasses(isActive)}>
              Inventory
            </NavLink>
            <NavLink to="/admin/clients" className={({ isActive }) => itemClasses(isActive)}>
              Client Manager
            </NavLink>
            <NavLink to="/admin/orders" className={({ isActive }) => itemClasses(isActive)}>
              Orders
            </NavLink>
            <NavLink to="/admin/company-payments" className={({ isActive }) => itemClasses(isActive)}>
              Company Payments
            </NavLink>
            <NavLink to="/admin/store-settings" className={({ isActive }) => itemClasses(isActive)}>
              Store Settings
            </NavLink>
            <NavLink
              to="/admin/shipping-methods"
              className={({ isActive }) => itemClasses(isActive)}
            >
              Shipping Methods
            </NavLink>
          </nav>
          <div className="text-xs uppercase tracking-wide text-muted-foreground mb-2 mt-4">Catalog</div>
          <nav className="space-y-1">
            <NavLink to="/admin/catalog/products" className={({ isActive }) => itemClasses(isActive)}>
              Products
            </NavLink>
            <NavLink to="/admin/catalog/filaments" className={({ isActive }) => itemClasses(isActive)}>
              Filaments
            </NavLink>
            <NavLink to="/admin/catalog/categories" className={({ isActive }) => itemClasses(isActive)}>
              Categories
            </NavLink>
          </nav>
        </div>
      </aside>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
// --- END PATCH: AdminLayout with left sidebar navigation and Outlet ---